module.exports = __webpack_public_path__ + "static/media/DSC03730.61f08d62.JPG";